import { styled } from '@mui/material/styles';
import { Accordion, AccordionDetails, AccordionSummary, Modal } from '@mui/material';

export const ModalFlexContainer = styled(Modal)({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
});

export const StyledAccordion = styled(Accordion)({
  '&:before': {
    display: 'none',
  },
  background: 'transparent',
  borderRadius: '0 !important',
  boxShadow: 'none',
  padding: 0,
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  fontSize: '15px',
  borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  padding: 0,
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  flexDirection: 'column',
});
